document.addEventListener("DOMContentLoaded", function () {

    const mainSlider = new Swiper('.main-product-slider', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
  
  window.mainProductSwiper = mainSlider;

    const thumbnailsSlider = new Swiper('.thumbnails-slider', {
        spaceBetween: 15,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            1280: {
                slidesPerView: 6
            }
        }
    });

    // Add click event listener to the thumbnails to control the main slider
    thumbnailsSlider.on('click', function (swiper, event) {
        if (event.target.closest('.swiper-slide')) {
            const clickedIndex = swiper.clickedIndex;
            mainSlider.slideToLoop(clickedIndex, 500, true);
        }
    });

    // Toggle fullscreen mode
    function toggleFullscreen() {
        document.querySelector('.main-product-slider__container').classList.toggle('fullscreen');
    }

    // Event listener for main slider clicks to enter fullscreen
    mainSlider.on('click', function () {
        toggleFullscreen();
    });

    // Exit fullscreen button functionality
    document.querySelector('.exit-fullscreen-btn').addEventListener('click', function () {
        toggleFullscreen();
    });
});

